import React from "react";
import "./otherincomehome.css";
import { t } from "i18next";
import { Header, TitleView, Button, BreadCrumb } from "../../components";
import otherIncomeImage from "../../../assets/svgs/postretmt/otherincomes.svg";
import * as Bl from "../../../businesslogic";
import {
  INCOME_CATEGORY,
  INCOME_FREQUENCY_TYPE,
  INCOME_TYPE,
} from "../../constants";
import { getIncomePathName, getUserId } from "../../common";

const newIncome = {
  incomecategory: INCOME_CATEGORY.OTHER,
  userid: '',
  frequencytype: INCOME_FREQUENCY_TYPE.YEARLY,
  incomefrequency: 1,
  incomeamount: 0,
  incomestartyear: 0,
  incomeendyear: 0,
  incometype: INCOME_TYPE.ONE_TIME,
  incomegrowthrate: 0,
  incomedescription: "",
  incomestartage: 0,
  incomeendage: 0,
};
class OtherHomePage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      newIncomeData: new Bl.Income({ ...newIncome, userid: getUserId() }),
      incomeData: [],
    };
  }

  onSelectItem(path) {
    this.props.navigate(path);
  }

  onPressAddButton() {
    this.props.navigate("/otherincomedetails", {
      state: { incomeData: this.state.newIncomeData, isEditView: false },
    });
  }



  renderNavView() {
    const items = getIncomePathName("Other_Income");
    const location = this.props.location;
    return (
      <BreadCrumb
        items={items}
        isLastPath={true}
        currentPath={location.pathname}
        onClickBackIcon={this.onSelectItem.bind(this)}
        onClickItem={this.onSelectItem.bind(this)}
      />
    );
  }

  renderTitleView() {
    const title = t("oiTitle");
    return <TitleView title={title} />;
  }

  renderImage() {
    return (
      <img src={otherIncomeImage} alt="Other Income" className="ohp_image" />
    );
  }

  renderDetails() {
    return <span className="ohp_details_text">{t("oiInfo")}</span>;
  }

  renderButton() {
    return (
      <div id="ohp_button_view">
        <Button
          buttonName={t("oiButton")}
          onPressButton={this.onPressAddButton.bind(this)}
        />
      </div>
    );
  }

  render() {
    return (
      <div id="ohp_container">
        {this.renderNavView()}
        <div id="ohp_inner_container">
          {this.renderTitleView()}
          {this.renderImage()}
          {this.renderDetails()}
          {this.renderButton()}
        </div>
      </div>
    );
  }
}
export default OtherHomePage;
